<button
  class="px-2 me-2"
  kendoButton
  fillMode="solid"
  rounded="large"
  themeColor="primary"
  [title]="
    _clientWO.bulkActionsDisabled()
      ? ('HOME.STREAM.DISABLED_TOOLTIP'
        | translate: { count: (_clientWO.loadedRowCount() | number) })
      : ('HOME_COMPONENTS.BLACKOUT.BLACKOUT' | translate)
  "
  [fillMode]="selectedWOstatus().length === 0 ? 'outline' : 'solid'"
  [disabled]="selectedWOstatus().length === 0 || _clientWO.bulkActionsDisabled()"
  (click)="showBlackout()"
  >
  <fa-icon [icon]="faCalendarDay" class="w-px-20 me-1"></fa-icon>
  {{ 'HOME_COMPONENTS.BLACKOUT.BLACKOUT' | translate }}
</button>

<button
  class="px-2 me-2"
  kendoButton
  fillMode="solid"
  rounded="large"
  themeColor="primary"
  [title]="
    _clientWO.bulkActionsDisabled()
      ? ('HOME.STREAM.DISABLED_TOOLTIP'
        | translate: { count: (_clientWO.loadedRowCount() | number) })
      : ('HOME_COMPONENTS.BLACKOUT.PLANNED_INSTALL_DATE' | translate)
  "
  [fillMode]="isPlannedInstalledDateDisabled() ? 'outline' : 'solid'"
  [disabled]="isPlannedInstalledDateDisabled() || _clientWO.bulkActionsDisabled()"
  (click)="onPlannedInstallDateClick()"
  >
  <fa-icon [icon]="faCalendarDay" class="w-px-20 me-1"></fa-icon>
  {{ 'HOME_COMPONENTS.BLACKOUT.PLANNED_INSTALL_DATE' | translate }}
</button>

<install-date-popup
  [show]="showInstallDate"
  [workorders]="getInstallDateSelection()"
  [contractname]="active()?.contractName"
  [total]="(_clientWO | async)?.length"
  (closeEvent)="showInstallDate = $event"
  (completedEvent)="complete($event)"
  >
</install-date-popup>

@if (showBlackoutWarning) {
  <kendo-dialog>
    <p class="m-4 p-4 text-center">
      {{ 'HOME_COMPONENTS.BLACKOUT.MULTIPLE_SELECTION_WARNING' | translate }}
    </p>
    <kendo-dialog-actions [layout]="'end'">
      <button kendoButton [themeColor]="'primary'" (click)="showBlackoutWarning = false">
        {{ 'HOME_COMPONENTS.COMMON.OK' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
